import { ArrowHeadRightIcon, Checkbox, Chip, Select, SelectOptionType, Tooltip } from '@bp/ui-components';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { lowercaseFirstLetter, naturalStringSort } from 'utils/stringHelper';
import { ColorType } from '../types';
import styles from './_PlanungImportForms.module.scss';

type PlanungImportClassesFormRowProps = {
  uuid: string;
  selected: boolean;
  name: string;
  grade: string;
  gradeGroup: string;
  color: ColorType;
  classes: { uuid: string; name: string }[];
  selectedClass: { value: string; label: string } | null;
  connected: boolean;
  onSelect: (isSelected: boolean) => void;
  onClassSelect: (uuid: string | null) => void;
};

export const PlanungImportClassesFormRow = ({
  uuid,
  selected,
  name,
  grade,
  gradeGroup,
  color,
  classes,
  selectedClass,
  connected,
  onSelect,
  onClassSelect,
}: PlanungImportClassesFormRowProps) => {
  const { t } = useTranslation();

  const classOptions: SelectOptionType[] = classes
    .map((c) => ({ value: c.uuid, label: c.name }))
    .sort((a, b) => naturalStringSort(a.label, b.label));

  return (
    <div className={classNames(styles['form-row'], styles.classes, { [styles.selected]: selected })}>
      <div>
        <Checkbox
          onChange={(event) => {
            onSelect(event.target.checked);
          }}
          checked={selected}
          name={`check-${uuid}`}
          label={name}
          preventLabelWrapping
        />
      </div>
      <div>{grade}</div>
      <div>{gradeGroup}</div>
      <div>
        <Tooltip content={color.colorLabel && color.colorLabel !== '' ? color.colorLabel : t('colors.notSpecified')}>
          <div className={styles['color-dot']} style={{ backgroundColor: color.color ?? '#fff' }}></div>
        </Tooltip>
      </div>
      <div>
        <ArrowHeadRightIcon />
      </div>
      <div>
        <Select
          dense
          options={classOptions}
          name={`select-class-${uuid}`}
          placeholder={selected ? lowercaseFirstLetter(t('planungImport.willBeCreated')) : undefined}
          onChange={(event) => {
            const selectOption = event as SelectOptionType;
            const uuid = selectOption ? (selectOption.value as string) : null;
            onClassSelect(uuid);
          }}
          value={selectedClass}
          isClearable
          isSearchable
          menuPosition='fixed'
          disabled={!selected}
        />
      </div>
      <div>
        <Chip
          isSmall
          value={connected ? <>&#10003;</> : <>&#8212;</>}
          color={connected ? 'var(--color-white)' : 'var(--color-grey-light)'}
          bgColor={connected ? 'var(--color-primary)' : 'var(--color-grey-lighter)'}
        />
      </div>
    </div>
  );
};
